import TriggerBase from "./Base";
import {useTranslation} from "react-i18next";

const LotReservationTrigger = ({trigger}) => {
    const { t } = useTranslation();
    return (
        <>
            <TriggerBase trigger={trigger} />
            <tr>
                <td>{t("lot.lot")}</td>
                <td>{trigger.lotName}</td>
            </tr>
            <tr>
                <td>{t("stateControllerService.valueNeeded")}</td>
                <td>{trigger.valueNeeded ? t("allgemein.an") : t("allgemein.aus")}</td>
            </tr>
        </>
    )
}

export default LotReservationTrigger
